import entryEn from './entry/en.json';
import entryZhHant from './entry/zh-Hant.json';
import entryTh from './entry/th.json';
import entryVi from './entry/vi.json';

export default {
  en: entryEn,
  'zh-Hant': entryZhHant,
  vi: entryVi,
  th: entryTh,
};
